export const routes = {
  dashboard: "/dashboard" as const,
  discover: "/discover" as const,
  myRecipes: "/my-recipes" as const,
  favorites: "/favorites" as const, // Keep for backward compatibility
  plans: "/plans" as const,
  shoppingList: "/shopping-list" as const,
  profile: "/profile" as const,
  kitchenProfile: "/profile/kitchen" as const,
  adminOverview: "/admin/overview" as const,
} as const;

export type RouteKey = keyof typeof routes;

export type RoutePath = (typeof routes)[RouteKey];

export const isRoutePath = (path: string): path is RoutePath => {
  return Object.values(routes).includes(path as RoutePath);
};
